import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import classes from './selectMoistureLogMaterialScreen.module.css';

interface Props {
  damageMaterials: any[];
  onClick: (e: any) => void;
}

function SelectMoistureLogMaterialScreen({ damageMaterials, onClick }: Props) {
  return (
    <div className="d-flex flex-column w-100">
      <div className={`list-group ${classes.listContainer}`}>
        {damageMaterials.map((material) => (
          <div
            key={material.id}
            role="button"
            className={`list-group-item-action ${classes.listItem}`}
            onClick={() => onClick(material)}
            onKeyUp={() => onClick(material)}
            tabIndex={0}
          >
            {material.name}
          </div>
        ))}
      </div>
    </div>
  );
}

const SelectMoistureLogMaterialScreenMemo = memo(SelectMoistureLogMaterialScreen, areEqual);
export { SelectMoistureLogMaterialScreenMemo as SelectMoistureLogMaterialScreen };
